module.exports = __webpack_public_path__ + "img/icon3.f9767d61.png";